module.exports = __webpack_public_path__ + "static/wikinomics-34675bb0a4aa324ded4b45e22428382f.jpg";